<template>
    <div>
        <b-modal id="modalCalibragem" data-backdrop="static" data-keyboard="false" centered
            :title="$t('Informar Calibragem') + ' - ' + nr_placa.nr_placa">

            <div id="globalAfericoes">

                <div id="veiculoPneus" class="veiculo-fixo text-center scalable">
                    <div class="chassi"></div>
                </div>

                <div v-if="pneuVazio" class="alert alert-danger text-center" role="alert">
                    Existem posições sem pneu aplicado!<br>
                    Entre no menu Movimentações e aplique<br> os pneus deste caminhão.
                </div>

                <modal-registra-calibragem ref="childRegistraAfericao" :pneu="informacaoPneu" v-if="modalShow"
                    :afericoesFeitas="arrayAfericoes" @closeModal="modalShow = false"
                    @adicionarCalibragem="adicionarCalibragem"></modal-registra-calibragem>

                <div class="container">
                    <div class="col-6 container">
                        <span class="">{{ $t('Informar KM') }}:</span>
                        <input type="text" class="form-control" v-model="km_informado">
                    </div>
                    <!-- <upload-arquivos-afericao></upload-arquivos-afericao> -->
                </div>
            </div>

            <template #modal-footer="{ cancel }">
                <div class="w-100">
                    <div class="row center" style="justify-content: center;">
                        <b-button class="mr-2" variant="danger" size="lg" @click="cancel(), modalShow = false">
                            {{ $t('Cancelar') }}
                        </b-button>
                        <b-button v-if="showBtnFinalizar" size="lg" variant="success"
                            :disabled="disabledFinalizar || pneuVazio" @click="registrarAfericao">
                            {{ $t('Informar Calibragem') }}
                        </b-button>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
// import UploadArquivosAfericao from '../Modais/UploadArquivosAfericao.vue';
import ModalRegistraCalibragem from './ModalRegistraCalibragem.vue';

export default {
    name: "ModalExterna",
    props: {
        nr_placa: {}
    },
    components: {
        // UploadArquivosAfericao,
        ModalRegistraCalibragem
    },

    data() {
        return {
            arrayAfericoes: [],
            informacaoPneu: '',
            modalShow: false,
            submitAfericao: [],
            disabledFinalizar: false,
            km_informado: '',
            showBtnFinalizar: true,
            pneuVazio: false
        };
    },

    computed: {
        veiculo() {
            const veiculo = this.$store.getters['borracharia/getVeiculo']

            // this.km_informado = veiculo

            return veiculo
        }
    },

    methods: {
        adicionarCalibragem(calibragem) {
            this.modalShow = false

            if (localStorage.calibragem == undefined) {
                const dataInicio = {
                    nr_placa: 'AAA000',
                    calibragem: []
                }
                localStorage.setItem('calibragem', JSON.stringify(dataInicio));
            }

            const localCalibragem = JSON.parse(localStorage.calibragem)

            if (this.nr_placa.nr_placa == localCalibragem.nr_placa) {
                this.submitCalibragem = localCalibragem.calibragem
            } else {
                this.submitCalibragem = []
            }

            var indice = this.submitCalibragem.findIndex(function (item) {
                if (item.nr_posicao && item.ds_lado) {
                    return item.nr_posicao === calibragem.nr_posicao && item.ds_lado === calibragem.ds_lado;
                }

                return -1
            });

            if (indice !== -1) {
                this.submitCalibragem[indice] = calibragem;
            } else {
                this.submitCalibragem.push(calibragem);
            }

            const todosPneus = document.querySelectorAll('.pneu-fixo')

            this.submitCalibragem.forEach(function (afe) {
                todosPneus.forEach((pneu) => {
                    if (pneu.dataset.posicao == afe.nr_posicao && pneu.dataset.lado == afe.ds_lado) {
                        pneu.classList.add('pneuSelecionadoAfericao')
                    }
                })
            })

            const data = {
                nr_placa: this.nr_placa.nr_placa,
                calibragem: this.submitCalibragem
            }

            localStorage.calibragem = JSON.stringify(data)

            if (data.calibragem.length === todosPneus.length) {
                this.disabledFinalizar = false
            }
            this.adicionarClassePneu()
        },

        gerarCaminhao() {
            this.km_informado = parseInt(this.veiculo.km_atual)
            let pneus = this.$store.getters['borracharia/getAfericao']

            console.log(pneus)

            for (let i = 1; i <= pneus.length; i++) {
                this.$nextTick(() => {
                    if (pneus[i]) {
                        var divChassi = document.createElement('div')

                        divChassi.classList.add(`eixo`)
                        divChassi.classList.add(`eixo-${pneus[i - 1].nr_posicao}`)

                        if (pneus[i].ds_lado == 'EEE') {
                            divChassi.classList.add(`eixo-estepe-1`)
                        }
                        if(pneus[i - 1].eixo_direcional){
                            divChassi.classList.add(`eixo-direcional-${pneus[i - 1].nr_posicao}`)
                        }

                        let divPai = document.getElementById('veiculoPneus')
                        divPai.classList.add(`margin-afericao-${pneus[i - 1].nr_posicao}`)

                        divPai.appendChild(divChassi)
                    }

                    // document.getElementById('chassi').style.width = `${pneus.length}00 px;`
                })
            }

            let divChassi = document.querySelector('.chassi')
            let contador_step = 0
            let contador_direcional = 1

            pneus.forEach((pneu, index) => {
                let divPneu = document.createElement('b-button')

                if(pneu.ds_lado == 'EEE') {
                        if(pneu.idpneu == null) return false

                        console.log('entrou')
                        console.log(pneu)
                        console.log(pneu.idpneu)
     
                        contador_step = contador_step + 1
                        divPneu.classList.add(`step-${contador_step}`)
                        divPneu.classList.add(`step-1`)
                        divChassi.classList.remove(`chassi-${pneu.nr_posicao}`)   
                        // divChassi.classList.add(`chassi-${pneu.nr_posicao}`)
                }

                divPneu.innerText = pneu.nr_fogo
                divPneu.value = pneu.vl_mm
                divPneu.dataset.idpneu = pneu.idpneu
                divPneu.dataset.posicao = pneu.nr_posicao
                divPneu.dataset.lado = pneu.ds_lado
                divPneu.dataset.vida = pneu.nr_vida

                divPneu.classList.add(`pneu-fixo`)
                divPneu.classList.add(`coluna-${pneu.nr_posicao}`)
                
                if(pneu.ds_lado != 'EEE') {
                    divChassi.classList.remove(`chassi-${pneu.nr_posicao}`)
                    divChassi.classList.add(`chassi-${pneu.nr_posicao}`)
                }

                if(pneu.eixo_direcional) {
                    contador_direcional = contador_direcional + 1
                    divPneu.classList.add(`pneu-direcional-${contador_direcional}`)
                    divChassi.classList.add(`chassi-direcional-${index}`)
                }

                // if(pneu.ds_lado == 'EEE') {
                //     console.log(pneu.nr_posicao)
                //     contador_step = contador_step + 1
                //     divPneu.classList.add(`step-${pneu.nr_posicao}`)
                //     divPneu.classList.add(`step-1`)
                //     divChassi.classList.remove(`chassi-${pneu.nr_posicao}`)
                // }  

                if (pneu.ds_lado == "EE") {
                    divPneu.classList.add('externo-esquerdo')
                } else if (pneu.ds_lado == "EI") {
                    divPneu.classList.add('interno-esquerdo')
                } else if (pneu.ds_lado == "DE") {
                    divPneu.classList.add('externo-direito')
                } else if (pneu.ds_lado == "DI") {
                    divPneu.classList.add('interno-direito')
                }

                let divPai = document.getElementById('veiculoPneus')

                divPai.appendChild(divPneu)
            })
        },

         

        adicionarClassePneu() {
            const todosPneus = document.querySelectorAll('.pneu-fixo')

            let aferTemp = {}

            let validaPneuVazio = false

            todosPneus.forEach((pneu) => {
                console.log(pneu)
                if(pneu.innerText == ''){
                    validaPneuVazio = true
                }
            }) 

            this.pneuVazio = validaPneuVazio
            if (localStorage.calibragem != undefined) {
                aferTemp = JSON.parse(localStorage.calibragem)

                todosPneus.forEach((pneu) => {
                    aferTemp.calibragem.forEach(function (afe) {
                        if (pneu.dataset.posicao == afe.nr_posicao && pneu.dataset.lado == afe.ds_lado) {
                            pneu.classList.add('pneuSelecionadoAfericao')
                        }
                    })
                })
            }

        },

        adicionarAcao() {
            const todosPneus = document.querySelectorAll('.pneu-fixo')

            todosPneus.forEach(acaoPneu => {
                acaoPneu.addEventListener('click', () => {
                    this.modalShow = false
                    const afericoesFeitas = acaoPneu.value
                    this.informacaoPneu = {
                        nr_fogo: acaoPneu.innerText,
                        idpneu: acaoPneu.dataset.idpneu,
                        nr_posicao: acaoPneu.dataset.posicao,
                        ds_lado: acaoPneu.dataset.lado,
                        nr_vida: acaoPneu.dataset.vida
                    }

                    // const arrayAfericoesTemp = afericoesFeitas.split('|')

                    // this.arrayAfericoes = arrayAfericoesTemp.map(function (string, indice) {
                    //     return { indice: indice, valor: string };
                    // });

                    this.modalShow = true
                    // this.showBtnFinalizar = !this.modalShow
                    setTimeout(() => {
                        var div = document.getElementById("globalAfericoes");
                        div.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
                        this.$refs.childRegistraAfericao.populaArray()

                    }, 100)

                })
            })
        },

        registrarAfericao() {
            const localCalibragem = JSON.parse(localStorage.calibragem)
            const todosPneus = document.querySelectorAll('.pneu-fixo')

            if (!this.km_informado) {
                this.$swal.fire({
                    title: 'Oops!',
                    text: 'Informe o KM atual',
                    icon: 'warning'
                })

                return false
            }
            if (localCalibragem.calibragem.length < todosPneus.length) {
                this.$swal.fire({
                    title: 'Oops!',
                    text: this.$t('Faça a leitura de todos os pneus para registrar'),
                    icon: 'warning'
                })

                return false
            }

            localCalibragem.km_informado = this.km_informado

            this.$store.dispatch('borracharia/submitCalibragem', { data: localCalibragem }).then(() => {
                this.limparAfericoes()
            })


            // if (document.getElementById('formFilesAfericao').value != '') {

            //     const files = this.$store.state.borracharia.filesUpload
            //     const formData = new FormData();

            //     for (let i = 0; i < files.length; i++) {
            //         formData.append('files[]', files[i]);
            //     }
            //     this.$store.dispatch('borracharia/submitAfericao', { data: localAfericao }).then(response => {
            //         localAfericao.nr_seq_evento = response.data.insert_eventos.nr_sequencial
            //         this.$store.dispatch(`borracharia/uploadFilesAfericao`, { data: formData, dataPneu: localAfericao })

            //         this.limparAfericoes()
            //     })

            // } else {
            //     this.$store.dispatch('borracharia/submitAfericao', { data: localAfericao }).then(() => {
            //         this.limparAfericoes()
            //     })
            // }


        },

        limparAfericoes() {
            this.submitAfericao = []

            const data = {
                nr_placa: '',
                afericoes: this.submitAfericao
            }

            localStorage.calibragem = JSON.stringify(data)

            this.$swal.fire({
                title: 'Sucesso!',
                text: this.$t('Leitura registrada com sucesso'),
                icon: 'success',
                timer: 1000
            })

            this.$bvModal.hide('modalCalibragem')
        }
    },
    created() {
        this.adicionarClassePneu()
    }
}
</script>

<style src="./style.css" />
